import { Dialog, styled } from "@mui/material";

export const BaseConfirmationModalWrapper = styled(Dialog)(({ theme }) => {
    return {
        "& h2": {
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: 40,
            lineHeight: "normal",
            textAlign: "center",
            overflow: "hidden",
            whiteSpace: "normal",
            textOverflow: "ellipsis",
            padding: "0 var(--basic-padding)",
        },
        "& .modal-heading": {
            padding: "var(--basic-padding) var(--basic-padding) 0",
            "& button": {
                background: "#828683",
                color: "#FFFFFF",
                float: "right",
            }
        },
        "& .modal-content": {
            padding: "var(--basic-padding)",
            overflowY: "unset",
        },
        "& .icon-box": {
            display: "flex",
            justifyContent: "center",
            padding: "var(--basic-padding)",
        },
        "& .MuiDialogActions-root": {
            gap: "var(--flex-gap)",
            padding: "0 var(--basic-padding) calc(var(--basic-padding) * 2)",
            "& button": {
                width: "100%"
            },
            [theme.breakpoints.down("tablet")]: {
                flexDirection: "column",
                gap: "calc(var(--flex-gap)/2)",
            }
        }
    }
})